import { authContextInterceptor } from './core/interceptors/auth-context.interceptor';
import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';

export const authProviders = [];

export const authInterceptors = [authTokenInterceptor, authContextInterceptor];
